import styled from 'styled-components';
import { vars } from '../../../theme';

// Wrapper that matches the column structure
export const StyledDividerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 1px;
    min-width: 1px;
    height: 100%;
    margin: 0 4px;
    align-self: stretch;
`;

// Spacer that matches the header height
export const StyledDividerHeaderSpacer = styled.div`
    height: 36px;
    flex-shrink: 0;
`;

// The actual divider line that matches the content container height
export const StyledDivider = styled.div<{ $color?: string }>`
    width: 1px;
    flex: 1 1 auto;
    min-height: 0;
    background-color: ${props => props.$color || vars.colors.stroke.secondary};
`;
